import React from "react";
import Newservices from "../../components/newservices/Newservices";
import Generalservices from "../../components/generalservices/Generalservices";
import Flashdeals from "../../components/flashdeals/Flashdeals";
import "./servicespage.css";
export default function Servicespage() {
  return (
    <div className="servicespagecont">
      <Flashdeals />
      <Newservices />
      <Generalservices />
    </div>
  );
}
